import { render, staticRenderFns } from "./DocumentIconBadge.vue?vue&type=template&id=3ae9f51e&scoped=true"
import script from "./DocumentIconBadge.vue?vue&type=script&lang=js"
export * from "./DocumentIconBadge.vue?vue&type=script&lang=js"
import style0 from "./DocumentIconBadge.vue?vue&type=style&index=0&id=3ae9f51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae9f51e",
  null
  
)

export default component.exports